function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import useDebugLevel from "../../hooks/useDebugLevel";
import { useMboxView } from "../AdobeTarget/cache/mboxes";
import { RemoteComponent } from "../RemoteComponent";
var defaultMapPropsToName = function(_, name) {
    return name;
};
var RemoteABTestDebugInfo = function(props) {
    var name = props.name, children = props.children, mapPropsToMboxName = props.mapPropsToMboxName, _props_mapPropsToName = props.mapPropsToName, mapPropsToName = _props_mapPropsToName === void 0 ? defaultMapPropsToName : _props_mapPropsToName;
    var mappedName = useMemo(function() {
        return (mapPropsToMboxName || mapPropsToName)(props, name);
    }, [
        mapPropsToMboxName,
        mapPropsToName,
        name,
        props
    ]);
    // Avoid rerendering on mbox updates unless we're debugging.
    var cachedMbox = useMboxView(mappedName);
    return /*#__PURE__*/ _jsx(RemoteComponent, {
        remote: "pepsFederatedModuleHost",
        component: "ABTestDebugInfo",
        props: _extends({}, props, {
            name: mappedName,
            originalName: name,
            cachedMbox: cachedMbox
        }),
        children: children
    });
};
var ABTestDebugInfo = function(props) {
    var children = props.children;
    // Can't use conditional hooks, but we can conditionally render.
    var debugLevel = useDebugLevel();
    return debugLevel ? /*#__PURE__*/ _jsx(RemoteABTestDebugInfo, _extends({}, props, {
        debugLevel: debugLevel
    })) : children;
};
export default ABTestDebugInfo;

//# sourceMappingURL=index.js.map